import { Button, Form, message, Popconfirm, Switch } from "antd";

import { useAppSelector } from "~/store/initializeStore";
import { useAddNutritionToTrainee } from "./hooks/useAddNutritionToTrainee";

type FormModel = {
  hasActiveNutrition: boolean;
  copySupplementsPlan: boolean;
};

export const TraineeNutritionAddAsCurrent = () => {
  const [form] = Form.useForm<FormModel>();
  const traineeProfile = useAppSelector((state) => state.trainee.profile);
  const { addSelectedNutritionToTrainee } = useAddNutritionToTrainee("scheduled", traineeProfile);
  const selectedMealsPlan = useAppSelector((state) => state.traineeMealsPlan.selectedMealsPlan);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (!selectedMealsPlan) {
        message.error("Nie znaleziono planu");
        return;
      }
      await addSelectedNutritionToTrainee(values, selectedMealsPlan);
    } catch (e) {
      message.error("Wystąpił błąd podczas dodawania diety jako aktualnej");
    }
  };

  const popoverContent = (
    <Form<FormModel>
      layout="vertical"
      form={form}
      initialValues={{ hasActiveNutrition: true, copySupplementsPlan: true }}
    >
      <Form.Item
        name="hasActiveNutrition"
        label="Udostępnij dietę klientowi"
        tooltip="Możesz udostępnić dietę natychmiast pod dodaniu lub w późniejszym czasie."
        valuePropName="checked"
      >
        <Switch />
      </Form.Item>
      <Form.Item label="Kopiuj suplementacje z obecnej diety" valuePropName="checked" name="copySupplementsPlan">
        <Switch />
      </Form.Item>
    </Form>
  );

  return (
    <Popconfirm
      description={popoverContent}
      onConfirm={handleOk}
      okText="Dodaj dietę"
      cancelText="Anuluj"
      title="Opcje diety"
      trigger="click"
    >
      <Button size="small" type="primary">
        Dodaj jako aktualną dietę
      </Button>
    </Popconfirm>
  );
};
